module.exports = __webpack_public_path__ + "static/media/col-watches.91e22f1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/col-watches.jpg
// module id = 1118
// module chunks = 33